import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { routerNameToSave } from "helper/routeHelper";
import { useRouteNavigation } from "hooks/useRouteNavigation";
import * as Styles from "./HealthAnalyse.styles";
import Check from "assets/images/health-analyse/check.svg";
import * as AwardStyles from "pages/healthAnalyse-Plan2/Challenge/Challenge.styles";

import { useNavigationRegistration } from "hooks/useNavigationRegistration";
import { IS_LOCAL } from "configs/utils";
import * as CoachActions from "redux/coach/coach.actions";
import { IMG_BASE_URL } from "pages/selectCoach/selectCoach";
import StarRatings from "react-star-ratings";
import { InsuranceSection } from "pages/healthAnalyse-Plan2/Start/Start";
import { clearOnboardingStorage } from "pages/onboarding/storage";
import HealthAnalyseSlider from "./HealthAnalyseSlider";
import AwardImage from "assets/images/health-analyse/award.png";

const advantagesList = [
  {
    id: 1,
    title: "Persönlicher Ernährungsplan",
    description:
      "Verrate mir in wenigen Schritten dein Ziel und ich werde dir deinen persönlichen Ernährungsplan erstellen und deine Ernährungsplaner-App einrichten.",
  },
  {
    id: 2,
    title: "Vorstellen deines Ernährungsplanes",
    description:
      "Ich werde dir deinen Ernährungsplan erklären. Hierbei gehe ich auf deinen Kalorienbedarf, die Ernährungsform und die Rezeptauswahl ein.",
  },
  {
    id: 1,
    title: "Wir starten gemeinsam",
    description:
      "Ich begleite dich auf dem Weg zu einer ganzheitlichen und gesunden Ernährungsumstellung und wir erreichen gemeinsam dein Ziel.",
  },
];

function HealthAnalyse({ currentPath }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { handleNavigate } = useRouteNavigation();

  const { coach, allNutritionsData } = useSelector((state) => state.coach);

  useEffect(() => {
    const coach_website_url = IS_LOCAL
      ? "https://sebastian-fci1.foodiary.app"
      : `${window.location.protocol}//${window.location.host}`;

    dispatch(
      CoachActions.trainerIdRequest({
        formData: { coach_website_url },
        callback: (res) => {
          dispatch(
            CoachActions.coachDataRequest({
              formData: { trainerID: res?.trainerID },
              callback: (res) => {
                console.log(res);
              },
            })
          );
        },
      })
    );
  }, []);

  routerNameToSave(location.state?.params ?? "");

  const handleNextPage = () => {
    clearOnboardingStorage();
    handleNavigate(currentPath);
  };
  useNavigationRegistration({}, handleNextPage);

  //   <Styles.ListItem>
  //   <span className="tick-icon">
  //     <img src={Check} alt="Check" />
  //   </span>
  //   <h3 className="bold-text">Ernährungsberater seit: </h3>
  //   <p> {trainerShowData?.step2}</p>
  // </Styles.ListItem>

  // Krankenkassen zertifiziert

  // Mehr Energie im Alltag

  // Gewicht verlieren & Muskeln aufbauen

  // Gesunde Ernährungsmethoden

  // Dauerhafter Erfolg ohne Jojo-Effekt

  // Persönliche Betreuung

  const List = [
    "Krankenkassen zertifiziert",
    "Mehr Energie im Alltag",
    "Gewicht verlieren & Muskeln aufbauen",
    "Gesunde Ernährungsmethoden",
    "Dauerhafter Erfolg ohne Jojo-Effekt",
    "Persönliche Betreuung",
  ];

  return (
    <Styles.MainContainer>
      <div className="main-div">
        <Styles.Container>
          <Styles.CredentialDescription>
            Als dein persönlicher Coach unterstütze ich dich beim Erstellen
            deines eigenen Ernährungsplanes und auf Wunsch begleite ich dich
            kostenlos bei der Umsetzung und dem Erreichen deines Zieles.
          </Styles.CredentialDescription>
          <Styles.CoachCard>
            <Styles.CoachImage>
              {/* Replace with actual coach image path */}
              <img
                src={IMG_BASE_URL + coach?.profilePic}
                alt="Felix Mergenthaler"
              />
            </Styles.CoachImage>
            <Styles.CoachInfo>
              <Styles.CoachLabel>Dein Coach:</Styles.CoachLabel>
              <Styles.CoachName>
                {coach?.prename} {coach?.surname}
              </Styles.CoachName>
              <Styles.RatingContainer>
                <StarRatings
                  rating={5}
                  starRatedColor="#FFC400"
                  numberOfStars={5}
                  starDimension="14px"
                  starSpacing="1px"
                />
                <Styles.Reviews>
                  50.000 Ernährungspläne durch Foodiary erstellt
                </Styles.Reviews>
              </Styles.RatingContainer>
              <Styles.DesktopCredentialsContainer>
                <Styles.CredentialItem hasBorder={true}>
                  <Styles.CredentialLabel>Ausbildungen:</Styles.CredentialLabel>
                  <Styles.CredentialValue>
                    {coach?.step3}
                  </Styles.CredentialValue>
                </Styles.CredentialItem>
                <Styles.CredentialItem hasBorder={true}>
                  <Styles.CredentialLabel>Coach für:</Styles.CredentialLabel>
                  <Styles.CredentialValue>
                    {coach?.subtitle}
                  </Styles.CredentialValue>
                </Styles.CredentialItem>
                <Styles.CredentialItem>
                  <Styles.CredentialLabel>Coach seit:</Styles.CredentialLabel>
                  <Styles.CredentialValue>
                    {coach?.step2}
                  </Styles.CredentialValue>
                </Styles.CredentialItem>
              </Styles.DesktopCredentialsContainer>
            </Styles.CoachInfo>
          </Styles.CoachCard>

          <Styles.MobileCredentialsContainer>
            <Styles.CredentialItem hasBorder={true}>
              <Styles.CredentialLabel>Ausbildungen:</Styles.CredentialLabel>
              <Styles.CredentialValue>{coach?.step3}</Styles.CredentialValue>
            </Styles.CredentialItem>
            <Styles.CredentialItem hasBorder={true}>
              <Styles.CredentialLabel>Coach für:</Styles.CredentialLabel>
              <Styles.CredentialValue>{coach?.subtitle}</Styles.CredentialValue>
            </Styles.CredentialItem>
            <Styles.CredentialItem>
              <Styles.CredentialLabel>Coach seit:</Styles.CredentialLabel>
              <Styles.CredentialValue> {coach?.step2}</Styles.CredentialValue>
            </Styles.CredentialItem>
          </Styles.MobileCredentialsContainer>
          <Styles.ContentContainer>
            <Styles.BenefitsTitle>So funktioniert's</Styles.BenefitsTitle>
            <div className="advantages">
              <div className="slider-container">
                {advantagesList.map((advantage) => (
                  <Styles.BenefitCard key={advantage.id}>
                    <Styles.BenefitHeader>
                      <Styles.BenefitCircle />
                      <Styles.BenefitTitle>
                        {advantage.title}
                      </Styles.BenefitTitle>
                    </Styles.BenefitHeader>
                    <Styles.BenefitDescription>
                      {advantage.description}
                    </Styles.BenefitDescription>
                  </Styles.BenefitCard>
                ))}
              </div>
              <HealthAnalyseSlider advantagesList={advantagesList} />

              <h3 className="header">Deine Vorteile</h3>
              {List.map((item, index) => (
                <Styles.ListItem key={index} index={index}>
                  <p className="bold-text">{item}</p>
                  <span className="tick-icon">
                    <img src={Check} alt="Check" />
                  </span>
                </Styles.ListItem>
              ))}
            </div>
            <div className="award-section">
              <AwardStyles.AwardSection>
                <div className="award-container">
                  <img src={AwardImage} alt="Award" className="award-icon" />
                  <div className="content-column">
                    <p className="title">Gesunde Gewohnheiten</p>
                    <p className="subtitle">12 Wochen Health Challenge</p>
                    <p className="description">Starten und gewinnen</p>
                  </div>
                </div>

                <h3 className="amount">1.000 €</h3>
              </AwardStyles.AwardSection>
            </div>
            <Styles.MarginTop>
              <InsuranceSection title="100% Kostenübernahme durch deine gesetzliche Krankenkasse:" />
            </Styles.MarginTop>
          </Styles.ContentContainer>
        </Styles.Container>
      </div>
    </Styles.MainContainer>
  );
}

export default HealthAnalyse;
